// Trusted Types default policy.
//
// The chlann CSP at vercel.json includes `require-trusted-types-for 'script'`
// and `trusted-types default`, which means every browser API that needs a
// TrustedScriptURL (notably navigator.serviceWorker.register) must receive
// one. Plain strings get routed through the policy named `default`, and if
// no `default` policy is registered the call is rejected with a TypeError.
//
// vite-plugin-pwa's auto-injected registerSW.js calls register('/sw.js')
// with a plain string. Without this policy in place the service worker
// never registers in production - PWA install, offline.html, push
// notifications, and Workbox runtime caching are all dead. Found by the
// 2026-05-29 deep audit (docs/audit/landing-seo-deep-audit-2026-05-29.md
// P1 #2 / N2).
//
// This file MUST be the first import in main.tsx so the policy is in place
// before any code (ours or vite-pwa's manual registerSW call) needs it.
//
// The policy refuses cross-origin script URLs so it cannot be used as a
// CSP bypass: a same-origin URL is the only thing it promotes.

if (typeof window !== 'undefined' && window.trustedTypes && typeof window.trustedTypes.createPolicy === 'function') {
  try {
    window.trustedTypes.createPolicy('default', {
      createScriptURL: (input: string): string => {
        try {
          const url = new URL(input, window.location.origin);
          if (url.origin === window.location.origin) {
            return input;
          }
        } catch {
          // fall through to throw below
        }
        throw new TypeError('TrustedTypes default policy refused script URL: ' + input);
      },
      createHTML: (input: string): string => input,
      createScript: (input: string): string => input,
    });
  } catch {
    // A previously-registered default policy will throw. Safe to ignore.
    if (typeof console !== 'undefined' && console.warn) {
      console.warn('[chlann] Trusted Types default policy already registered');
    }
  }
}
